/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DInputs */

const cs_enum_d = /** @type {(inputs: Enum_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D`)
};

const en_enum_d = /** @type {(inputs: Enum_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D`)
};

/**
* | output |
* | --- |
* | "D" |
*
* @param {Enum_DInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_d = /** @type {((inputs?: Enum_DInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_d(inputs)
	return cs_enum_d(inputs)
});